import { Box, Button, LinearProgress } from '@mui/material'
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight'
import FooterBtn from './FooterBtn'
import { useAppStore } from '../store/useAppStore'
import useCurrentStepInfo from '../hooks/useCurrentStepInfo'
import { useTranslation } from 'react-i18next'

const Footer = () => {
  const vehicleData = useAppStore((state) => state.vehicleData)
  const tabValue = useAppStore((state) => state.tabValue)
  const setTabValue = useAppStore((state) => state.setTabValue)
  const setAlertDialog = useAppStore((state) => state.setAlertDialog)
  const setIsKmInputVisible = useAppStore((state) => state.setIsKmInputVisible)
  const { t } = useTranslation()

  const handleForward = () => {
    if (vehicleData[tabValue] && !vehicleData[tabValue].photo) {
      setAlertDialog({
        open: true,
        header: t('alert_dialog.photo_required.title'),
        message: t('alert_dialog.photo_required.message'),
      })
    } else {
      let newValue = tabValue + 1
      while (true) {
        if (vehicleData[newValue]) {
          if (!vehicleData[newValue].photo) {
            setTabValue(newValue)
            break
          } else {
            newValue++
          }
        } else {
          newValue = 0
        }
      }
    }
  }

  const handleBackward = () => {
    let newValue = tabValue - 1
    while (true) {
      if (vehicleData[newValue]) {
        if (vehicleData[newValue].photo) {
          setTabValue(newValue)
          break
        } else {
          newValue--
        }
      } else {
        newValue = 3
      }
    }
  }

  const {
    currentProgress: progress,
    isCurrentStep,
    isLastStep,
  } = useCurrentStepInfo(vehicleData, tabValue)

  return isLastStep ? (
    <Box
      sx={{
        width: '100%',
        position: 'fixed',
        bottom: 0,
        backgroundColor: '#fff',
        zIndex: '10',
        '.Mui-disabled': {
          pointerEvents: 'initial',
        },
      }}
    >
      <FooterBtn
        title={t('footer.register_mileage')}
        handleClick={() => setIsKmInputVisible(true)}
      />
    </Box>
  ) : (
    <Box
      sx={{
        width: '100%',
        position: 'fixed',
        bottom: 0,
        backgroundColor: '#fff',
        zIndex: '10',
        '.Mui-disabled': {
          pointerEvents: 'initial !important',
        },
      }}
    >
      <LinearProgress
        variant="determinate"
        value={progress}
        sx={{
          height: 2,
          position: 'absolute',
          width: '100%',
        }}
      />
      <Box
        display="flex"
        justifyContent={isCurrentStep ? 'space-between' : 'flex-end'}
        px={2}
        py={1.75}
      >
        {isCurrentStep && (
          <Button color="primary" onClick={() => handleBackward()}>
            {t('footer.back')}
          </Button>
        )}
        <Button
          variant="contained"
          color="primary"
          endIcon={<KeyboardArrowRightIcon />}
          disableElevation
          className={!vehicleData[tabValue].photo ? 'Mui-disabled' : ''}
          onClick={() => handleForward()}
        >
          {t('footer.next')}
        </Button>
      </Box>
    </Box>
  )
}

export default Footer
